import type { FC } from 'react';
import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { connect } from 'react-redux';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from './theme/GlobalStyles';
import { createTheme } from './theme';
import routes from './routes';
import RTL from './components/global/RTL';
import { onValidateToken } from './store/actions/auth';

const theme = createTheme({
  direction: 'ltr',
  responsiveFontSizes: true,
  roundedCorners: true,
  theme: 'LIGHT',
});

const App: FC<any> = ({ onValidateToken: onValidateTokenExecutor }) => {
  useEffect(() => {
    const token = localStorage.getItem('token');
    onValidateTokenExecutor({ token });
  }, []);

  const content = useRoutes(routes);

  return (
    <ThemeProvider theme={theme}>
      <RTL direction="ltr">
        <GlobalStyles />
        {content}
      </RTL>
    </ThemeProvider>
  );
};

const stateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(stateToProps, { onValidateToken })(App);
